/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useInput, BooleanInput } from 'react-admin';

const SilentUpdateInput = (props) => {
  const {
    input: { onChange, name, value, ...rest },
  } = useInput(props);

  const handleChangeInput = (newValue) => {
    console.log('dddd', newValue);
    onChange(newValue ? 'true' : '');
  };

  return (
    <React.Fragment>
      <BooleanInput
        name={name}
        label={props.label}
        onChange={handleChangeInput}
        options={{
          checked: value,
        }}
        helperText="Please activate this mode before you make any update to the files if you want the update to be transparent with no update to the end user. This state will stay until it is manually modified again"
        {...rest}
      />
    </React.Fragment>
  );
};

SilentUpdateInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

SilentUpdateInput.defaultProps = {
  record: {},
};

export default SilentUpdateInput;
